import { Grid } from '@mui/material';
import React from 'react';
import { NumberInputWidget } from 'src/components/widget';

interface PositionBoxProps {
  x: number;
  y: number;
  onChange: (x: number, y: number) => void;
}

export const PositionBox = (props: PositionBoxProps) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      direction="row"
      wrap="nowrap"
      gap={1}>
      <NumberInputWidget
        label="X-axis"
        onChange={(value) => props.onChange(value as number, props.y)}
        value={props.x}
      />
      <NumberInputWidget
        label="Y-axis"
        onChange={(value) => props.onChange(props.x, value as number)}
        value={props.y}
      />
    </Grid>
  );
};
